/* V3 header: mega menus, mobile sheet (from netra-website-v2 v3.js) */
(function () {
  "use strict";
  var $ = function (s, c) {
    return (c || document).querySelector(s);
  };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };
  var RM = matchMedia("(prefers-reduced-motion: reduce)").matches;

  var hdr = $("[data-nav]");
  if (hdr) {
    var scrollIdleTimer = 0;
    var onScroll = function () {
      hdr.classList.toggle("is-stuck", scrollY > 8);
      document.documentElement.classList.add("is-scrolling");
      clearTimeout(scrollIdleTimer);
      scrollIdleTimer = setTimeout(function () {
        document.documentElement.classList.remove("is-scrolling");
      }, 120);
    };
    onScroll();
    addEventListener("scroll", onScroll, { passive: true });

    var triggers = $$(".hdr__trigger", hdr);
    var fine = matchMedia("(hover: hover) and (pointer: fine)").matches;
    var openId = null;
    var shutTimer = null;

    var bg = $(".mega-bg", hdr);
    var leaving = {};
    var FADE = RM ? 0 : 200;

    var place = function (id) {
      var m = document.getElementById(id);
      var card = m && m.querySelector(".mega__panel");
      var t = triggers.filter(function (x) {
        return x.dataset.mega === id;
      })[0];
      if (!card || !t) return null;
      card.style.transform = "";
      var wrap = card.parentElement;
      var pad = parseFloat(getComputedStyle(wrap).paddingRight) || 0;
      var cr = card.getBoundingClientRect();
      var room = wrap.getBoundingClientRect().right - pad - cr.right;
      var dx = Math.max(0, Math.min(t.getBoundingClientRect().left - 12 - cr.left, room));
      dx = Math.round(dx);
      if (dx) card.style.transform = "translateX(" + dx + "px)";
      var hr = hdr.getBoundingClientRect();
      return { x: cr.left + dx - hr.left, y: cr.top - hr.top, w: cr.width, h: cr.height };
    };

    var fit = function (id, morph) {
      var r = bg && place(id);
      if (!r) return;
      bg.classList.toggle("no-morph", !morph);
      bg.style.transform = "translate(" + r.x + "px," + r.y + "px)";
      bg.style.width = r.w + "px";
      bg.style.height = r.h + "px";
      if (!morph) void bg.offsetWidth;
      bg.classList.add("is-on");
    };

    var show = function (id) {
      clearTimeout(shutTimer);
      if (openId === id) return;
      var prev = openId;
      openId = id;
      triggers.forEach(function (t) {
        t.setAttribute("aria-expanded", String(t.dataset.mega === id));
      });
      if (prev) {
        var pm = document.getElementById(prev);
        if (pm) {
          clearTimeout(leaving[prev]);
          pm.classList.add("is-leaving");
          leaving[prev] = setTimeout(function () {
            pm.classList.remove("is-leaving");
            if (openId !== prev) pm.hidden = true;
          }, FADE);
        }
      }
      if (id) {
        var m = document.getElementById(id);
        clearTimeout(leaving[id]);
        m.classList.remove("is-leaving");
        m.hidden = false;
        fit(id, !!prev);
      } else if (bg) {
        bg.classList.remove("is-on");
      }
      hdr.classList.toggle("is-open", !!id);
    };
    addEventListener("resize", function () {
      if (openId) fit(openId, false);
    });

    var hide = function (focusTrigger) {
      var was = openId;
      show(null);
      if (focusTrigger && was) {
        var t = triggers.filter(function (x) {
          return x.dataset.mega === was;
        })[0];
        if (t) t.focus();
      }
    };
    var hideSoon = function () {
      clearTimeout(shutTimer);
      shutTimer = setTimeout(function () {
        show(null);
      }, 160);
    };

    triggers.forEach(function (t) {
      var id = t.dataset.mega;
      var panel = document.getElementById(id);
      t.addEventListener("click", function (e) {
        e.stopPropagation();
        openId === id ? hide() : show(id);
      });
      if (!fine) return;
      t.addEventListener("pointerenter", function () {
        show(id);
      });
      t.addEventListener("pointerleave", hideSoon);
      var card = panel && (panel.querySelector(".mega__panel") || panel);
      if (card) {
        card.addEventListener("pointerenter", function () {
          clearTimeout(shutTimer);
        });
        card.addEventListener("pointerleave", hideSoon);
      }
    });

    $$(".mega a", hdr).forEach(function (a) {
      a.addEventListener("click", function () {
        show(null);
      });
    });

    if (fine) {
      document.addEventListener(
        "pointerover",
        function (e) {
          if (!openId) return;
          var n = e.target;
          if (n && n.nodeType === 1 && (n.closest(".hdr__trigger") || n.closest(".mega__panel"))) return;
          hideSoon();
        },
        { passive: true }
      );
    }

    document.addEventListener("click", function (e) {
      if (!hdr.contains(e.target)) show(null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && openId) hide(true);
    });

    var burger = $(".hdr__burger", hdr);
    var sheet = $(".sheet", hdr);
    if (burger && sheet) {
      burger.addEventListener("click", function () {
        var open = sheet.hidden;
        sheet.hidden = !open;
        burger.setAttribute("aria-expanded", String(open));
        document.documentElement.style.overflow = open ? "hidden" : "";
      });
      $$("a,.btn", sheet).forEach(function (a) {
        a.addEventListener("click", function () {
          sheet.hidden = true;
          burger.setAttribute("aria-expanded", "false");
          document.documentElement.style.overflow = "";
        });
      });
      addEventListener("resize", function () {
        if (innerWidth > 1020 && !sheet.hidden) {
          sheet.hidden = true;
          burger.setAttribute("aria-expanded", "false");
          document.documentElement.style.overflow = "";
        }
      });
    }
  }
})();
